import { onScopeDispose, watch, type Ref } from 'vue'

const locks = new Map<HTMLElement, { count: number; previous: boolean }>()

/** Teleported menus/sheets leave the legacy pages mounted but non-interactive. */
export function useMmShellInert(open: Ref<boolean>) {
  let shell: HTMLElement | null = null
  const release = () => {
    if (!shell) return
    const lock = locks.get(shell)
    if (lock && --lock.count === 0) { shell.inert = lock.previous; locks.delete(shell) }
    shell = null
  }
  watch(open, visible => {
    release()
    if (!visible || typeof document === 'undefined') return
    shell = document.querySelector<HTMLElement>('.app-shell')
    if (!shell) return
    const lock = locks.get(shell) || { count: 0, previous: shell.inert }
    lock.count++
    locks.set(shell, lock)
    shell.inert = true
  }, { immediate: true, flush: 'post' })
  onScopeDispose(release)
}
